export default __webpack_public_path__ + "static/media/idcard_front.3d38e981.jpg";